import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/x-circle.svg'


const _hoisted_1 = { class: "\n      pt-8\n      bg-white\n      flex flex-col\n      text-12px xxl:text-14px\n      overflow-hidden\n      h-screen\n      relative\n      w-full\n    " }
const _hoisted_2 = { class: "grid gap-6 grid-cols-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "col-span-2" }, null, -1)
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "\n                  bg-red-lp-300\n                  rounded-full\n                  text-white\n                  flex flex-col\n                  px-6\n                  py-2\n                " }
const _hoisted_6 = { class: "text-20px font-semibold" }
const _hoisted_7 = { class: "w-2/12" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "py-3" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_9 = { class: "flex items-end justify-between" }
const _hoisted_10 = { class: "flex gap-x-16" }
const _hoisted_11 = { class: "space-y-2" }
const _hoisted_12 = { class: "font-semibold text-black-lp-300" }
const _hoisted_13 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_14 = { class: "space-y-2" }
const _hoisted_15 = { class: "font-semibold text-black-lp-300" }
const _hoisted_16 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_17 = { class: "space-y-2" }
const _hoisted_18 = { class: "font-semibold text-black-lp-300" }
const _hoisted_19 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_20 = { class: "space-y-2" }
const _hoisted_21 = { class: "font-semibold text-black-lp-300" }
const _hoisted_22 = { class: "font-semibold text-20px text-red-lp-300" }
const _hoisted_23 = { class: "flex gap-x-4" }
const _hoisted_24 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_25 = { class: "w-full relative" }
const _hoisted_26 = { class: "flex flex-col justify-center items-center w-full mt-2" }
const _hoisted_27 = { class: "col-span-4 space-y-1" }
const _hoisted_28 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_29 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "check-circle"
}, null, -1)
const _hoisted_30 = { class: "text-12px text-black-lp-300" }
const _hoisted_31 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_32 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "x-circle"
}, null, -1)
const _hoisted_33 = { class: "text-12px text-black-lp-300" }
const _hoisted_34 = { class: "flex flex-row" }
const _hoisted_35 = { class: "flex flex-col space-y-3" }
const _hoisted_36 = { class: "text-20px font-semibold text-black-lp-200" }
const _hoisted_37 = { class: "space-y-1" }
const _hoisted_38 = { class: "text-12px xxl:text-14px text-gray-lp-600 pr-12" }
const _hoisted_39 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_40 = { class: "text-gray-lp-600 text-12px xxl:text-14px" }
const _hoisted_41 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 mr-2",
  alt: "check-circle"
}, null, -1)
const _hoisted_42 = { class: "text-gray-lp-300 text-12px xxl:text-14px" }
const _hoisted_43 = { class: "flex justify-end space-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Notification = _resolveComponent("Notification")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_DetailLayout, {
        onBack: _ctx.goBack,
        title: _ctx.$t('deliveryManifest.createManifest'),
        "vertical-separator": false,
        fullPage: "",
        "is-floating-action": ""
      }, {
        data: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('deliveryManifest.form.partnerName'),
              class: "col-span-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.dataProfile.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataProfile.name = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('deliveryManifest.form.userType'),
              class: "col-span-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.typeUser,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.typeUser = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _hoisted_3,
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('deliveryManifest.form.destinationCity'),
              class: "col-span-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.originCity,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.originCity = $event)),
                  placeholder: "-",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('deliveryManifest.form.createdAt'),
              class: "col-span-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Datepicker, {
                  class: "mt-1.5",
                  disabled: "",
                  modelValue: _ctx.form.date,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.date = $event)),
                  placeholder: _ctx.$t('deliveryManifest.form.createdAt')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              class: "col-span-4",
              label: _ctx.$t('deliveryManifest.form.sttNo')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  ref: "inputStt",
                  onEnter: _ctx.addScanSttNumber,
                  sizeInput: "24px",
                  labelStacked: _ctx.$t('deliveryManifest.form.sttExample'),
                  modelValue: _ctx.form.sttNumber,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.sttNumber = $event)),
                  placeholder: _ctx.$t('deliveryManifest.form.sttPlaceholder'),
                  bold: !!_ctx.form.sttNumber,
                  error: !_ctx.isPaid,
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isPaid = true)),
                  errorCaption: 
                !_ctx.isPaid
                  ? _ctx.$t('deliveryManifest.form.sttOverweightError')
                  : ''
              
                }, null, 8, ["onEnter", "labelStacked", "modelValue", "placeholder", "bold", "error", "errorCaption"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_ctx.isMaxStt)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  class: "col-span-2 flex flex-row items-center justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode("img", {
                      src: require(`@/app/ui/assets/svg/warning.svg`),
                      class: "w-28 mr-3",
                      alt: "warning"
                    }, null, 8, ["src"]),
                    _createVNode("div", _hoisted_4, [
                      _createVNode("div", _hoisted_5, [
                        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('deliveryManifest.form.maxStt', { max: _ctx.maxSttNumber })), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_LpButton, {
              onClick: _ctx.addSttNumber,
              customClass: "px-12 py-2.5",
              title: _ctx.$t('deliveryManifest.button.add'),
              textColor: "white",
              disabled: _ctx.isDisableAddSttNumber
            }, null, 8, ["onClick", "title", "disabled"])
          ]),
          (_ctx.dataSttToBeCreate.length > 0 && !_ctx.isFailed)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_8,
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('deliveryManifest.column.totalStt')), 1),
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.totalStt), 1)
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('deliveryManifest.column.totalPiece')), 1),
                      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.totalPieces), 1)
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('deliveryManifest.column.totalGrossWeight')), 1),
                      _createVNode("div", _hoisted_19, _toDisplayString(_ctx.isValueDecimal(_ctx.convertTotalKg(_ctx.totalGrossWeight))) + " Kg ", 1)
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('deliveryManifest.column.totalVolumeWeight')), 1),
                      _createVNode("div", _hoisted_22, _toDisplayString(_ctx.isValueDecimal(_ctx.convertTotalKg(_ctx.totalVolumeWeight))) + " Kg ", 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_LpButton, {
                      outline: "",
                      iconLeft: "delete",
                      title: _ctx.$t('deliveryManifest.button.delete'),
                      onClick: _ctx.onShowDelete,
                      textColor: "red-lp-300"
                    }, null, 8, ["title", "onClick"]),
                    _createVNode(_component_LpButton, {
                      onClick: _ctx.togglePanel,
                      icon: 
                  _ctx.$refs.op?.visible ? 'chevron-up-white' : 'chevron-down-white'
                ,
                      title: _ctx.$t('deliveryManifest.button.process'),
                      textColor: "white"
                    }, null, 8, ["onClick", "icon", "title"]),
                    _createVNode(_component_OverlayPanel, {
                      ref: "op",
                      appendTo: "body",
                      style: {"width":"auto"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_LpButton, {
                          class: "w-60",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.createAndPrint(false))),
                          flat: "",
                          dense: "",
                          iconLeft: "delivery",
                          title: _ctx.$t('deliveryManifest.createManifest')
                        }, null, 8, ["title"]),
                        _hoisted_24,
                        _createVNode(_component_LpButton, {
                          class: "w-full",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.createAndPrint(true))),
                          flat: "",
                          dense: "",
                          iconLeft: "printer",
                          title: _ctx.$t('deliveryManifest.button.createAndPrint')
                        }, null, 8, ["title"])
                      ]),
                      _: 1
                    }, 512)
                  ])
                ]),
                _createVNode("div", _hoisted_25, [
                  _createVNode(_component_TableV2, {
                    data: _ctx.dataSttToBeCreate,
                    columns: _ctx.columns,
                    borderTop: false,
                    isRightFreeze: true,
                    totalColumnFreeze: 0,
                    isPinnedScrollBottom: false,
                    pagination: _ctx.pagination,
                    "is-hard-pagination": true,
                    "is-quick-search": true,
                    "is-sorting": true,
                    "pagination-style": "v2"
                  }, null, 8, ["data", "columns", "pagination"])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onBack", "title"])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onDownload : _ctx.alertPopup.onClick
    ,
      onClose: _ctx.isPartial || _ctx.isFailed ? _ctx.alertPopup.onClick : () => {},
      title: _ctx.alertPopup.title,
      message: _ctx.$t(_ctx.alertPopup.message),
      image: _ctx.alertPopup.image,
      textSuccess: _ctx.alertPopup.isTextBtnConfirmH2H ? _ctx.$t('deliveryManifest.modal.understood') : _ctx.isPartial || _ctx.isFailed ? _ctx.$t('deliveryManifest.modal.download') : _ctx.$t('deliveryManifest.modal.ok'),
      textCancel: _ctx.isPartial || _ctx.isFailed ? _ctx.$t('deliveryManifest.modal.ok') : '',
      class: "px-8",
      customButton: _ctx.isPartial ? 'px-10' : 'px-6'
    }, {
      custom: _withCtx(() => [
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _withDirectives(_createVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('deliveryManifest.modal.countSuccess', { count: _ctx.countSuccess })), 1)
            ], 512), [
              [_vShow, _ctx.isPartial]
            ]),
            _withDirectives(_createVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('deliveryManifest.modal.countFailed', { count: _ctx.countFailed })), 1)
            ], 512), [
              [_vShow, _ctx.isPartial || _ctx.isFailed]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel", "customButton"]), [
      [_vShow, 
      _ctx.openSuccess ||
        _ctx.isErrorTyping ||
        _ctx.isFailed ||
        _ctx.isPartial ||
        _ctx.isErrorValidationScan
    ]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('deliveryManifest.modal.leaveTitle'),
      message: _ctx.$t('deliveryManifest.modal.leaveMessage'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('deliveryManifest.modal.leave'),
      textCancel: _ctx.$t('deliveryManifest.modal.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationLeave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onSave,
      onClose: _ctx.handleConfirmationSave,
      title: _ctx.$t('deliveryManifest.modal.confirmCreateTitle'),
      message: _ctx.$t('deliveryManifest.modal.confirmMessage'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('deliveryManifest.button.process'),
      textCancel: _ctx.$t('deliveryManifest.modal.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openConfirmationSave]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.closeBlockDem,
      title: _ctx.$t('deliveryManifest.modal.scanFailedTitle'),
      message: _ctx.$t('deliveryManifest.modal.rtsHalMessage'),
      image: "circle-error",
      textSuccess: _ctx.$t('deliveryManifest.modal.ok'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.isBlockDem]
    ]),
    _createVNode(_component_Notification, {
      modelValue: _ctx.notification,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.notification = $event)),
      onClose: _ctx.onCloseNotification,
      data: _ctx.detailSttNotification,
      status: _ctx.isUnpaidNotification ? 'error' : 'success'
    }, null, 8, ["modelValue", "onClose", "data", "status"]),
    _createVNode(_component_Dialog, {
      modelValue: _ctx.showDeleteSttNumber,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDeleteSttNumber = $event)),
      persistent: true
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_34, [
          _createVNode("img", {
            src: 
          require(`@/app/ui/assets/svg/${
            _ctx.sttNumberSuccessDelete ? 'delete-success' : 'delete-confirm'
          }.svg`)
        ,
            class: "w-40 mr-12",
            alt: "delete-success"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_35, [
            _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('deliveryManifest.deleteDialog.title')), 1),
            _createVNode("div", _hoisted_37, [
              _createVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('deliveryManifest.deleteDialog.description')), 1),
              _createVNode(_component_LpInput, {
                ref: "deleteStt",
                error: _ctx.errorSttNumberDelete !== '',
                errorCaption: _ctx.errorSttNumberDelete,
                modelValue: _ctx.sttNumberToDelete,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.sttNumberToDelete = $event)),
                onEnter: _ctx.onDeleteSttNumber
              }, null, 8, ["error", "errorCaption", "modelValue", "onEnter"])
            ]),
            (_ctx.sttNumberListTrash.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('deliveryManifest.deleteDialog.deleted')), 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttNumberListTrash, (item) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "flex flex-row",
                      key: item
                    }, [
                      _hoisted_41,
                      _createVNode("div", _hoisted_42, _toDisplayString(item), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_43, [
          _createVNode(_component_LpButton, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showDeleteSttNumber = false)),
            customClass: "px-10 py-2",
            textColor: "red-lp-100",
            outline: "",
            title: _ctx.$t('deliveryManifest.button.cancel'),
            class: "mt-10"
          }, null, 8, ["title"]),
          _createVNode(_component_LpButton, {
            disabled: _ctx.sttNumberToDelete === '',
            onClick: _ctx.onDeleteSttNumber,
            customClass: "px-10 py-2",
            textColor: "white",
            title: _ctx.$t('deliveryManifest.button.delete'),
            class: "mt-10"
          }, null, 8, ["disabled", "onClick", "title"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode("img", {
      id: "logo",
      src: require(`@/app/ui/assets/images/logo-${_ctx.roleAccount}.png`),
      class: "hidden",
      alt: "logo"
    }, null, 8, ["src"])
  ], 64))
}